import { CredentialField } from './CredentialField'
import { useState, type FormEvent } from 'react'
import { Button, Icon, Prompt, PromptActions, PromptBody, Title, toastSuccess } from 'admination-react'
import { changePassword } from '@/core/api/auth'
import {
  CHANGE_DONE,
  CHANGE_FAILED,
  PASSWORD_MISMATCH,
  PASSWORD_MISSING,
  passwordPolicyMessage,
  tooManyAttemptsMessage,
} from './messages'

export function ChangePasswordPrompt({ onClose }: { onClose: () => void }) {
  const [alt, setAlt] = useState('')
  const [neu, setNeu] = useState('')
  const [wiederholung, setWiederholung] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault()
    if (busy) return
    if (!alt || !neu || !wiederholung) {
      setError(PASSWORD_MISSING)
      return
    }
    if (neu !== wiederholung) {
      setError(PASSWORD_MISMATCH)
      return
    }
    setBusy(true)
    setError(null)
    try {
      await changePassword(alt, neu)
    } catch (err) {
      setError(tooManyAttemptsMessage(err) ?? passwordPolicyMessage(err) ?? CHANGE_FAILED)
      setBusy(false)
      return
    }
    toastSuccess(CHANGE_DONE)
    onClose()
  }

  return (
    <Prompt onEscape={onClose} busy={busy} aria-labelledby="change-password-title">
      <PromptBody>
        <Title as="h3" id="change-password-title">
          Passwort ändern
        </Title>
        <form
          id="change-password-form"
          onSubmit={(e) => void submit(e)}
          noValidate
          className="section-body"
        >
          <CredentialField label="Aktuelles Passwort" id="change-password-current" name="current-password" type="password"
            autoComplete="current-password" value={alt} onChange={setAlt}
            disabled={busy} />
          <CredentialField label="Neues Passwort" id="change-password-new" name="new-password" type="password"
            autoComplete="new-password" value={neu} onChange={setNeu}
            disabled={busy} />
          <CredentialField label="Neues Passwort wiederholen" id="change-password-repeat" name="new-password-repeat" type="password"
            autoComplete="new-password" value={wiederholung} onChange={setWiederholung}
            disabled={busy} />
          {error && (
            <p role="alert" className="field-error">
              {error}
            </p>
          )}
        </form>
      </PromptBody>
      <PromptActions>
        <Button onClick={onClose} disabled={busy}>
          Abbrechen
        </Button>
        <Button type="submit" form="change-password-form" variant="primary" loading={busy}>
          <Icon name="i-check" />Passwort ändern
        </Button>
      </PromptActions>
    </Prompt>
  )
}
